import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"px-3 bg-gray-200",staticStyle:{"padding":"1px 0"}},[_c(VIcon,{attrs:{"size":"20"}},[_vm._v("mdi-format-list-checks")]),_c('span',{staticClass:"ml-1 font-14 font-weight-medium"},[_vm._v("DRP / Lista de Separação de Produtos ")])],1),_c(VTabs,{attrs:{"centered":""}},[_c(VTab,[_vm._v("Lista de Separação")])],1),_c(_setup.GridListas,{staticClass:"mx-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }